/**
 * AI 分类「下载命名弹窗」的类型化封装
 *
 * photoFolders 下的两个下载弹窗是旧 JS（PropTypes / connect），没有 TS 类型。
 * 这里补一层 props 类型声明再导出，供 AI 分类列表页 / 详情页共用，避免裸用 any。
 *  · FolderDownloadModal · 文件夹级下载（命名规则 + 时间范围）
 *  · PhotoDownloadModal  · 照片级下载（"照片/视频命名方式"，含照片标题候选）
 */
import type { ComponentType } from 'react'
import DownloadModalRaw from '../../photoFolders/components/DownloadModal'
import DownloadPhotosModalRaw from '../../photoFolders/components/DownloadPhotosModal'

/** 下载命名弹窗里的「水印标题」候选项（文件夹标题 / 照片标题通用） */
export interface FolderPhotoTitle {
  titleId: string
  titleName: string
}

/** 「文件夹下载」弹窗 props */
export interface FolderDownloadModalProps {
  visible: boolean
  /** 确认下载 · 回传解析好的命名规则数组与毫秒级时间范围 */
  onOk: (
    namingRule: string[],
    timeParams: { startTime?: number; endTime?: number }
  ) => void
  /** 命名规则里的「水印标题」候选项 */
  folderPhotoTitlesList: FolderPhotoTitle[]
  onClose: () => void
  /** 是否批量下载 · 仅影响弹窗内埋点 */
  isBatchDownload?: boolean
  /** 批量下载选中的文件夹 id（弹窗内埋点用） */
  selectedFolderIds?: number[]
}

export const FolderDownloadModal =
  DownloadModalRaw as ComponentType<FolderDownloadModalProps>

/** 「照片下载」弹窗 props */
export interface PhotoDownloadModalProps {
  visible: boolean
  /** 照片级命名候选（"照片/视频命名方式"下拉里的水印标题项） */
  photoTitleList: FolderPhotoTitle[]
  /** 文件夹级命名候选（弹窗内部回显用，UI 上的归类区已注释隐藏） */
  folderTitleList: FolderPhotoTitle[]
  /** 确认下载 · 回传解析好的命名规则数组（diy: / title: / 预设项） */
  onOk: (namingRule: string[]) => void
  onClose: () => void
}

export const PhotoDownloadModal =
  DownloadPhotosModalRaw as ComponentType<PhotoDownloadModalProps>
